export const PPV_MOVIE = 'ppvMovie';
export const BOOK ="book"
export const PLAYLIST = "playlist"
export const NEWS_ARTICLE = "newsArticle"
export const TRACK = "track"
export const TRACKS = "tracks"
export const ALBUM = "album"
export const TOUR  = 'tour'
export const PERFORMANCE = 'performance'
